package navigation.home.organization

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.file.domain.repository.FileRepository
import com.essntl.features.organization.domain.repository.OrganizationRepository
import com.essntl.features.organization.ui.OrganizationEvent
import com.essntl.features.organization.ui.OrganizationState
import com.essntl.features.organization.ui.OrganizationValidation
import com.essntl.features.organization.ui.OrganizationViewModel

class OrganizationScreenModel(
    organizationRepository: OrganizationRepository,
    fileRepository: FileRepository,
    loadingManager: LoadingManager,
) : StateScreenModel<OrganizationState>(OrganizationState()) {
    val validation = OrganizationValidation()

    private val vm =
        OrganizationViewModel(
            organizationRepository = organizationRepository,
            fileRepository = fileRepository,
            loadingManager = loadingManager,
            state = mutableState,
            scope = screenModelScope,
        )

    fun onEvent(event: OrganizationEvent) = vm.onEvent(event)
}